meedy.factory('meedy.termService', ['$q', '$rootScope', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function($q, $rootScope, baseService, objectHelper, config) {

        function TermService() {

            this.getUpcomingTermsWithSkip = function(skipCount) {
                return baseService.get(config.API_URL + '/terms/upcoming/' + skipCount).then(
                    function(successResponse) {

                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getUpcomingTerms = function() {
                return baseService.get(config.API_URL + '/terms/upcoming').then(
                    function(successResponse) {

                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getTermDetails = function(idTerm) {
                return baseService.get(config.API_URL + '/terms/details/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getMonthlyCalendarData = function(startDate) {
                return baseService.get(config.API_URL + '/terms/monthlyData?startDate=' + startDate).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createNewInternalAppointment = function(term) {
                return baseService.post(config.API_URL + '/terms/newInternalTerm', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createTerm = function(term) {
                var request = objectHelper.convertDatesToTimes(term);
                return baseService.post(config.API_URL + '/terms/createOrUpdate', request).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateTerm = function(term) {
                var request = objectHelper.convertDatesToTimes(term);
                return baseService.post(config.API_URL + '/terms/createOrUpdate', request).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createNewPrivateTerm = function(term) {
                return baseService.post(config.API_URL + '/terms/newPrivateTerm', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermWrapperMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getCalendarData = function(startDate, calendarType, idResource) {
                return baseService.get(config.API_URL + '/terms/getCalendarData?startDate=' + startDate + '&calendarType=' + calendarType + '&resourceId=' + idResource).then(
                    function(successResponse) {
                        //var data = objectHelper.translateArray(successResponse, TermWrapperMeedyVO);
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateInternalTermData = function(term) {
                return baseService.post(config.API_URL + '/terms/updateInternalTerm', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updatePrivateTermData = function(term) {
                return baseService.post(config.API_URL + '/terms/updatePrivateTermData', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.cancelAppointment = function(termId, statusReasonId, statusDescription) {
                var request = {
                    idStatusReason: statusReasonId,
                    statusDescription: statusDescription
                };

                return baseService.post(config.API_URL + '/terms/cancelAppointment/' + termId, request).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteTerm = function(idTerm) {
                return baseService.delete(config.API_URL + '/terms/delete/' + idTerm).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getStatusReasons = function() {
                return baseService.get(config.API_URL + '/terms/getStatusReasons').then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, StatusReasonMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.verifyAppointment = function(termId, verificationCode) {
                var request = {
                    idTerm: termId,
                    verificationCode: verificationCode
                };

                $rootScope.ignoreError.push(config.API_URL + '/terms/verifyAppointment');
                return baseService.post(config.API_URL + '/terms/verifyAppointment', request).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAppointmentBillings = function(idTerm) {
                return baseService.get(config.API_URL + '/terms/getAppointmentBillings/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, AppointmentBillingOfferMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.executeAppointmentBillings = function(idTerm, dataWrapper) {
                return baseService.post(config.API_URL + '/terms/executeAppointmentBillings/' + idTerm, dataWrapper).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.executeAppointment = function(termId, updateAppointmentWrapper) {
                return baseService.post(config.API_URL + '/terms/executeAppointment/' + termId, updateAppointmentWrapper).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.beginAppointment = function(termId) {
                return baseService.post(config.API_URL + '/terms/begin/' + termId).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.checkConflicts = function(term) {
                $rootScope.ignoreError.push(config.API_URL + '/terms/checkConflicts');
                return baseService.post(config.API_URL + '/terms/checkConflicts', term).then(
                    function(successResponse) {
                        var data = objectHelper.translateArray(successResponse, TermMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.updateCyclicTerm = function(mode, term) {
                return baseService.put(config.API_URL + '/terms/updateCyclicTerm/' + mode, term).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, TermMeedyVO);
                        data = objectHelper.convertTimesToDates(data);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.deleteCyclicTerm = function(mode, idTerm) {
                return baseService.delete(config.API_URL + '/terms/deleteCyclicTerm/' + mode + '/' + idTerm).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.begin = function(idTerm) {
                return baseService.post(config.API_URL + '/terms/begin/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, EdmVisitDetailsMeedyVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.edmVisit = function(idTerm) {
                return baseService.get(config.API_URL + '/terms/edmVisit/' + idTerm).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, VisitVO);
                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getAttachments = function(idTerm) {
                return baseService.get(config.API_URL + '/streaming/terms/' + idTerm + '/attachments').then(
                  function(successResponse) {
                      var data = objectHelper.translateArray(successResponse, TermAttachmentVO);
                      return data;
                  },
                  function(errorResponse) {
                      return $q.reject(errorResponse);
                  }
                );
            };

            this.downloadAttachment = function (idTerm, idAttachment, name) {

                if(name.indexOf('.png') > -1 || name.indexOf('.jpg') > -1) {

                    return baseService.get(config.API_URL + '/streaming/terms/' + idTerm + '/attachments/' + idAttachment, {responseType: 'arraybuffer'}).then(
                      function (successResponse) {
                          var blob = new Blob([successResponse], { type: "image/jpeg" } );
                          var pdfLink = (window.URL || window.webkitURL).createObjectURL( blob );

                          var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
                            ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);

                          if(ie || ie11) {
                              window.navigator.msSaveBlob(blob, name);

                          } else {

                              var a = document.createElement('a');
                              a.href = pdfLink;
                              a.target = '_blank';
                              a.download = name;

                              document.body.appendChild(a);
                              a.click();
                          }

                          return successResponse;
                      },
                      function (errorResponse) {
                          return $q.reject(errorResponse);
                      }
                    );

                } else if(name.indexOf('.pdf')) {

                    return baseService.get(config.API_URL + '/streaming/terms/' + idTerm + '/attachments/' + idAttachment, {responseType: 'arraybuffer'}).then(
                      function (successResponse) {
                          var blob = new Blob([successResponse], { type : 'application/pdf' });
                          var pdfLink = (window.URL || window.webkitURL).createObjectURL( blob );

                          var ie = navigator.userAgent.match(/MSIE\s([\d.]+)/),
                            ie11 = navigator.userAgent.match(/Trident\/7.0/) && navigator.userAgent.match(/rv:11/);

                          if(ie || ie11) {
                              window.navigator.msSaveBlob(blob, name);

                          } else {

                              var a = document.createElement('a');
                              a.href = pdfLink;
                              a.target = '_blank';
                              a.download = 'Dokument_' + name;

                              document.body.appendChild(a);
                              a.click();
                          }

                          return successResponse;
                      },
                      function (errorResponse) {
                          return $q.reject(errorResponse);
                      }
                    );

                }
            };

            this.getTerms = function(criteria) {
                return baseService.post(config.API_URL + '/terms/getTerms', criteria).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.executeAllForTerm = function(term) {
                return baseService.post(config.API_URL + '/terms/' + term.id + '/executeAll').then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.reverseStatusForTerm = function(term) {
                return baseService.post(config.API_URL + '/terms/' + term.id + '/reverseStatus').then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.createAlabAppointment = function(term) {
                return baseService.post(config.API_URL + '/terms/alab', term).then(
                    function(successResponse) {
                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new TermService();
    }
]);
